import React, { useState, useEffect } from 'react';
import './index.css';
import { FormGroup, Container, Col, Row, Form, Input, Label } from 'reactstrap';
import moment from 'moment';
import {
  getTerritories,
  addDealer,
  editDealer,
  getStateDistrictCity,
} from '../../../constants/apiCalls';
import { useNavigate, useLocation } from 'react-router-dom';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { CommonButton } from '../../../Components/CommonComponents';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  dealerInfoAction,
  DEALER_DETAIL,
} from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import DateService from '../../../services/DateService';
import { dateFormat } from '../../../constants/dateFormat';

const BusinessInfo = () => {
  const navigate = useNavigate();
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [slectedState, setSelectedState] = useState('');
  const [selectedTerritory, setSelectedTerritory] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState('');
  const [selectedDistrictId, setSelectedDistrictId] = useState('');
  const [selectedCityId, setSelectedCityId] = useState('');
  const [title, setTitle] = useState({});
  const [isKycRequired, setIsKycRequired] = useState(false);
  let location = useLocation();
  const initialValues = {
    pincode: '',
    Website: '',
    FbPgLink: '',
    frontAge: null,
    depth: null,
    ceilingHeight: null,
    incorporateDate: '',
    address: '',
    businessName: '',
    selected: '',
    businessType: '',
    currentRadioValue: '',
    noOfEmployees: '',
    noOfFarmers: '',
    noOfRetailOutlets: '',
    landlineNumber: '',
    totalAreaStorage: null,
    stdCode: '',
  };
  const [formValues, setFormValues] = useState(initialValues);
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector((state) => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    } else {
      dispatch({
        type: DEALER_DETAIL,
        data: {},
      });
    }
  }, []);

  useEffect(() => {
    if (userId) {
      setFormValues({
        pincode: dealerObj.pincode,
        totalAreaStorage: dealerObj.total_area_of_storage,
        noOfRetailOutlets: dealerObj.no_of_retial_outlets,
        noOfEmployees: dealerObj.no_of_employees,
        noOfFarmers: dealerObj.no_of_farmers,
        frontAge: dealerObj.frontage,
        depth: dealerObj.depth,
        ceilingHeight: dealerObj.ceiling_height,
        businessName: dealerObj.business_name,
        address: dealerObj.address,
        incorporateDate: dealerObj && dealerObj.business_incorporation_date ? DateService.utcToLocalDateOnly(dealerObj.business_incorporation_date, dateFormat.DATE_FORMAT_4) : "",
        selected: dealerObj.territory,
        businessType: dealerObj.business_type,
        currentRadioValue: dealerObj.application_for,
        Website: dealerObj.website,
        FbPgLink: dealerObj.facebook_page,
        landlineNumber: dealerObj.landline_number,
        stdCode: dealerObj.std_code,
      });

      setSelectedStateId(dealerObj.state_id);
      setSelectedDistrictId(dealerObj.district_id);
      setSelectedCityId(dealerObj.city_id);

      setIsKycRequired(dealerObj.is_approved);
      setTitle({ name: dealerObj.business_name, page: dealerObj.page_1 });
    }
  }, [dealerObj]);

  console.log("selecteeedCity", {selectedCityId, dealerObj, selectedCity, selectedStateId, slectedState})

  const options = [
    { id: 1, name: 'Sole proprietorship' },
    { id: 2, name: 'Partnership Firm' },
    { id: 3, name: 'Pvt.ltd.' },
    { id: 4, name: 'Ltd.' },
  ];

  useEffect(() => {
    getTerritoryData();
  }, []);

  const getTerritoryData = () => {
    getTerritories((res) => {
      const { success, data, error } = res;
      if (success === true) {
        setSelectedTerritory(data);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
    });
  };

  useEffect(() => {
    if (formValues.pincode && formValues.pincode.length === 6) {
      getPincodeCityStateDistrict(formValues.pincode);
      setSelectedDistrictId('');
      setSelectedCityId('');
      setIsloading(true);
    }
  }, [formValues.pincode]);

  const getPincodeCityStateDistrict = (pincode) => {
    let payload = {
      pincode: pincode,
    };
    getStateDistrictCity((res) => {
      const { success, data, error } = res;
      if (success === true) {
        if (data.length > 0) {
          let allData = data;
          // state array
          let stateArr = [
            ...new Map(allData.map((m) => [m.state_id, m])).values(),
          ]; // remove duplicate state
          setSelectedState(stateArr);
          setSelectedStateId(stateArr[0].state_id); //unique state id

          // District array
          let districtArr = [
            ...new Map(allData.map((m) => [m.district_id, m])).values(),
          ]; // remove duplicate district
          setSelectedDistrict(districtArr);

          // city Arr
          let cityArr = [
            ...new Map(allData.map((m) => [m.city_id, m])).values(),
          ]; // remove duplicate City
          setSelectedCity(cityArr);

          setIsloading(false);
        } else {
          ModalService.openAlert('', 'Please Insert Correct Pincode', 'error');
          setFormValues({ ...formValues, pincode: '' });
          setSelectedState('');
          setSelectedDistrict('');
          setSelectedCity('');
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsloading(false);
    }, payload);
  };

  const handleStateChange = (e) => {
    let val = e.target.value;
    setSelectedStateId(val);
  };

  useEffect(() => {
    handleDistrictChange();
  }, [selectedDistrictId, selectedStateId]);

  const handleDistrictChange = () => {
    if (selectedDistrictId && selectedStateId) {
      let payload = {
        pincode: formValues.pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if ((success === true) & (data.length > 0)) {
          let distrcitBaseCity = data.filter(
            (elem) => elem.district_id === +selectedDistrictId,
          );
          setSelectedCity(distrcitBaseCity);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleCityChange = (e) => {
    let val = e.target.value;
    setSelectedCityId(val);
  };

  const handleChange = (e, key) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    if (name === 'pincode' && value.length < 6) {
      setSelectedState('');
      setSelectedDistrict('');
      setSelectedCity('');
      setSelectedStateId('');
      setSelectedDistrictId('');
      setSelectedCityId('');
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let payload = {
      territory: formValues.selected ? [parseInt(formValues.selected)] : [],
      application_for: formValues.currentRadioValue || '',
      business_name: formValues.businessName || '',
      business_type: formValues.businessType || '',
      business_incorporation_date: formValues.incorporateDate
        ? formValues.incorporateDate
        : null,
      address: formValues.address || '',
      pincode: formValues.pincode || '',
      state_id: selectedStateId ? selectedStateId : null,
      district_id: selectedDistrictId ? selectedDistrictId : null,
      city_id: selectedCityId ? selectedCityId : null,
      landline_number: formValues.landlineNumber || '',
      no_of_retial_outlets: formValues.noOfRetailOutlets || '',
      no_of_employees: formValues.noOfEmployees || '',
      no_of_farmers: formValues.noOfFarmers || '',
      frontage: parseFloat(formValues.frontAge) || '',
      depth: parseFloat(formValues.depth) || '',
      ceiling_height: parseFloat(formValues.ceilingHeight) || '',
      total_area_of_storage: parseFloat(formValues.totalAreaStorage) || '',
      website: formValues.Website || '',
      facebook_page: formValues.FbPgLink || '',
      std_code: formValues.stdCode || '',
      page_1: 1,
    };
    let editPayload = {
      id: parseInt(userId),
      territory: formValues.selected ? [parseInt(formValues.selected)] : [],
      application_for: formValues.currentRadioValue || '',
      business_name: formValues.businessName || '',
      business_type: formValues.businessType || '',
      business_incorporation_date: formValues.incorporateDate
        ? formValues.incorporateDate
        : null,
      address: formValues.address || '',
      pincode: formValues.pincode || '',
      state_id: selectedStateId ? selectedStateId : null,
      district_id: selectedDistrictId ? selectedDistrictId : null,
      city_id: selectedCityId ? selectedCityId : null,
      landline_number: formValues.landlineNumber || '',
      no_of_retial_outlets: formValues.noOfRetailOutlets || '',
      no_of_employees: formValues.noOfEmployees || '',
      no_of_farmers: formValues.noOfFarmers || '',
      frontage: parseFloat(formValues.frontAge) || '',
      depth: parseFloat(formValues.depth) || '',
      ceiling_height: parseFloat(formValues.ceilingHeight) || '',
      total_area_of_storage: parseFloat(formValues.totalAreaStorage) || '',
      website: formValues.Website || '',
      facebook_page: formValues.FbPgLink || '',
      std_code: formValues.stdCode || '',
      page_1: 1,
    };
    if (!editPayload.id) {
      setIsloading(true);
      addDealer((res) => {
        const { success, message, data, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          Storage.setAddNewDealerId(data.id);
          Storage.removeEditNewDealerId();
          setTimeout(() => {
            Storage.removeLastBreadcrumbsRoute();
            navigate(`/pages/new-dealer/${Storage.getAddNewDealerId()}`);
          }, 3000);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    } else if (editPayload.id) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          Storage.setEditNewDealerId(editPayload.id);
          Storage.removeAddNewDealerId();
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setIsloading(false);
        }
        setIsloading(false);
      }, editPayload);
    }
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let payload = {
      territory: formValues.selected ? [parseInt(formValues.selected)] : [],
      application_for: formValues.currentRadioValue || '',
      business_name: formValues.businessName || '',
      business_type: formValues.businessType || '',
      business_incorporation_date: formValues.incorporateDate || '',
      address: formValues.address || '',
      pincode: formValues.pincode || '',
      state_id: selectedStateId ? selectedStateId : null,
      district_id: selectedDistrictId ? selectedDistrictId : null,
      city_id: selectedCityId ? selectedCityId : null,
      landline_number: formValues.landlineNumber || '',
      no_of_retial_outlets: formValues.noOfRetailOutlets || '',
      no_of_employees: formValues.noOfEmployees || '',
      no_of_farmers: formValues.noOfFarmers || '',
      frontage: formValues.frontAge ? parseFloat(formValues.frontAge) : null,
      depth: formValues.depth ? parseFloat(formValues.depth) : null,
      ceiling_height: formValues.ceilingHeight
        ? parseFloat(formValues.ceilingHeight)
        : null,
      total_area_of_storage: formValues.totalAreaStorage
        ? parseFloat(formValues.totalAreaStorage)
        : null,
      website: formValues.Website || '',
      facebook_page: formValues.FbPgLink || '',
      std_code: formValues.stdCode || '',
      page_1: 0,
    };
    let editPayload = {
      id: userId,
      territory: formValues.selected ? [parseInt(formValues.selected)] : null,
      application_for: formValues.currentRadioValue || '',
      business_name: formValues.businessName || '',
      business_type: formValues.businessType || '',
      business_incorporation_date: formValues.incorporateDate || '',
      address: formValues.address || '',
      pincode: formValues.pincode || '',
      state_id: selectedStateId ? selectedStateId : null,
      district_id: selectedDistrictId ? selectedDistrictId : null,
      city_id: selectedCityId ? selectedCityId : null,
      landline_number: formValues.landlineNumber || '',
      no_of_retial_outlets: formValues.noOfRetailOutlets || '',
      no_of_employees: formValues.noOfEmployees || '',
      no_of_farmers: formValues.noOfFarmers || '',
      frontage: formValues.frontAge ? parseFloat(formValues.frontAge) : null,
      depth: formValues.depth ? parseFloat(formValues.depth) : null,
      ceiling_height: formValues.ceilingHeight
        ? parseFloat(formValues.ceilingHeight)
        : null,
      total_area_of_storage: formValues.totalAreaStorage
        ? parseFloat(formValues.totalAreaStorage)
        : null,
      website: formValues.Website || '',
      facebook_page: formValues.FbPgLink || '',
      std_code: formValues.stdCode || '',
      page_1: 0,
    };
    if (!editPayload.id && payload) {
      setIsloading(true);
      addDealer((res) => {
        const { success, message, data, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          Storage.setAddNewDealerId(data.id);
          Storage.removeEditNewDealerId();
          setTimeout(() => {
            Storage.removeLastBreadcrumbsRoute();
            navigate(`/pages/new-dealer/${Storage.getAddNewDealerId()}`);
          }, 3000);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    } else if (editPayload.id) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          Storage.setEditNewDealerId(editPayload.id);
          Storage.removeAddNewDealerId();
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setIsloading(false);
        }
        setIsloading(false);
      }, editPayload);
    }
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="BusinessInfo">
              {isLoading && <CustomSpinner />}
              <div className="pageWrapper">
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title="Business Information" />
                    </Col>
                  </Row>
                  <div className="businessBlock">
                    <div className="businessBlockInner">
                      <Row>
                        <Col xs={12}>
                          <div className="dealerRegBlocktitle text-center noprint">
                            Business Information
                          </div>
                        </Col>
                      </Row>
                      <Form onSubmit={handleSubmit}>
                        <div className="innerArea">
                          <Row>
                            <Col lg={4} md={4}>
                              <FormGroup>
                                <Label className="distributor-label">
                                  Select Territory<span className="required">*</span>
                                </Label>
                                <div className="select-wrapper">
                                  <Input
                                    type="select"
                                    name="selected"
                                    required
                                    value={
                                      formValues.selected === null ||
                                        formValues.selected === 'undefined'
                                        ? ''
                                        : formValues.selected
                                    }
                                    id="select"
                                    onChange={(e) => handleChange(e, 12)}
                                  >
                                    <option disabled value={''}>
                                      Select
                                    </option>
                                    {selectedTerritory.length > 0 &&
                                      selectedTerritory.map((territory, index) => {
                                        return (
                                          <option key={index} value={territory.id}>
                                            {territory.name}
                                          </option>
                                        );
                                      })}
                                  </Input>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col lg={4} md={4}>
                              <span className="application-for-label">
                                Application for<span className="required">*</span>
                              </span>
                              <div className="radio-group">
                                <FormGroup className="radio-distributor">
                                  <Input
                                    type="radio"
                                    name="currentRadioValue"
                                    required
                                    onChange={(e) => handleChange(e, 13)}
                                    checked={
                                      formValues.currentRadioValue === 'Distributor'
                                    }
                                    style={{ paddingTop: '5px' }}
                                    value={'Distributor'}
                                  />
                                  <Label className="distributor-label">
                                    Distributor
                                  </Label>
                                </FormGroup>
                                <FormGroup className="radio-dealer">
                                  <Input
                                    type="radio"
                                    style={{ paddingTop: '5px' }}
                                    onChange={(e) => handleChange(e, 13)}
                                    name="currentRadioValue"
                                    required
                                    checked={formValues.currentRadioValue === 'Dealer'}
                                    value={'Dealer'}
                                  />
                                  <Label className="dealer-label">Dealer</Label>
                                </FormGroup>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <h3 className="dealerRegBlocktitleInner">Business Details</h3>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Dealership Name<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  value={
                                    formValues.businessName === null ||
                                      formValues.businessName === 'undefined'
                                      ? ''
                                      : formValues.businessName
                                  }
                                  type="text"
                                  required
                                  autoComplete="off"
                                  onChange={(e) => handleChange(e, 7)}
                                  placeholder="Type Here"
                                  name="businessName"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Business Type<span className="required">*</span>
                                </Label>
                                <div className="select-wrapper">
                                  <Input
                                    type="select"
                                    value={
                                      formValues.businessType === null ||
                                        formValues.businessType === 'undefined'
                                        ? ''
                                        : formValues.businessType
                                    }
                                    id="select"
                                    required
                                    name="businessType"
                                    onChange={(e) => handleChange(e, 8)}
                                  >
                                    <option disabled value={''}>
                                      Select
                                    </option>
                                    {options.length > 0 &&
                                      options.map((business, index) => {
                                        return (
                                          <option key={index} value={business.name}>
                                            {business.name}
                                          </option>
                                        );
                                      })}
                                  </Input>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Business Incorporation Date
                                  <span className="required">*</span>
                                </Label>
                                <Input
                                  type="date"
                                  max={moment(new Date()).format('YYYY-MM-DD')}
                                  maxLength="4"
                                  pattern="[1-9][0-9]{3}"
                                  onChange={(e) => handleChange(e, 9)}
                                  value={
                                    formValues.incorporateDate === null ||
                                      formValues.incorporateDate === 'undefined'
                                      ? ''
                                      : formValues.incorporateDate
                                  }
                                  required={!formValues.incorporateDate}
                                  className="calendar-input"
                                  name="incorporateDate"
                                  id="myDate"
                                />
                              </FormGroup>
                            </Col>

                            {formValues.currentRadioValue === 'Distributor' ? (
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Number of dealers working with
                                    <span className="required">*</span>
                                  </Label>
                                  <Input
                                    className="common-input"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    value={
                                      formValues.noOfRetailOutlets === null ||
                                        formValues.noOfRetailOutlets === 'undefined'
                                        ? ''
                                        : formValues.noOfRetailOutlets
                                    }
                                    onChange={(e) => handleChange(e, 3)}
                                    placeholder="Type Here"
                                    name="noOfRetailOutlets"
                                  />
                                </FormGroup>
                              </Col>
                            ) : null}
                            {formValues.currentRadioValue === 'Dealer' ? (
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Number of farmers working with
                                    <span className="required">*</span>
                                  </Label>
                                  <Input
                                    className="common-input"
                                    value={
                                      formValues.noOfFarmers === null ||
                                        formValues.noOfFarmers === 'undefined'
                                        ? ''
                                        : formValues.noOfFarmers
                                    }
                                    type="text"
                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    autoComplete="off"
                                    onChange={(e) => handleChange(e, 7)}
                                    placeholder="Type Here"
                                    name="noOfFarmers"
                                  />
                                </FormGroup>
                              </Col>
                            ) : null}
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  No. of Employees<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  value={
                                    formValues.noOfEmployees === null ||
                                      formValues.noOfEmployees === 'undefined'
                                      ? ''
                                      : formValues.noOfEmployees
                                  }
                                  type="text"
                                  required
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  onChange={(e) => handleChange(e, 7)}
                                  placeholder="Type Here"
                                  name="noOfEmployees"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <h3 className="dealerRegBlocktitleInner">Address</h3>
                          <Row>
                            <Col md={4}>
                              <FormGroup className="d-flex flex-column">
                                <Label className="common-input-label">
                                  Address<span className="required">*</span>
                                </Label>
                                <Input
                                  type="textarea"
                                  name="address"
                                  value={
                                    formValues.address === null ||
                                      formValues.address === 'undefined'
                                      ? ''
                                      : formValues.address
                                  }
                                  className="address-area w-100"
                                  required
                                  onChange={(e) => handleChange(e, 10)}
                                  cols="20"
                                  rows="5"
                                ></Input>
                              </FormGroup>
                            </Col>
                            <Col md={8}>
                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      Pincode<span className="required">*</span>
                                    </Label>
                                    <Input
                                      className="address-input"
                                      value={
                                        formValues.pincode === null ||
                                          formValues.pincode === 'undefined'
                                          ? ''
                                          : formValues.pincode
                                      }
                                      minLength={6}
                                      maxLength={6}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      type="text"
                                      required
                                      autoComplete="off"
                                      onChange={(e) => handleChange(e, 11)}
                                      placeholder="Type Here"
                                      name="pincode"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      State<span className="required">*</span>
                                    </Label>
                                    <div className="select-wrapper">
                                      <Input
                                        type="select"
                                        id="select"
                                        required
                                        multiple={false}
                                        value={selectedStateId || ""}
                                        onChange={handleStateChange}
                                      >
                                      <option disabled value={''}>
                                            Select
                                          </option>
                                        {slectedState.length > 0 ? (
                                          slectedState.map((state, index) => {
                                            return (
                                              <option
                                                key={index}
                                                value={state.state_id}
                                              >
                                                {state.state_name}
                                              </option>
                                            );
                                          })
                                        ) :("")}
                                      </Input>
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      District<span className="required">*</span>
                                    </Label>
                                    <div className="select-wrapper">
                                      <Input
                                        type="select"
                                        id="select"
                                        required
                                        multiple={false}
                                        value={selectedDistrictId || ""}
                                        onChange={(e) => {
                                          setSelectedDistrictId(e.target.value);
                                          setSelectedCityId('');
                                        }}
                                      >
                                        <option disabled value={''}>
                                          Select
                                        </option>
                                        {selectedDistrict.length > 0
                                          ? selectedDistrict.map((district, index) => {
                                            return (
                                              <option
                                                key={index}
                                                value={district.district_id}
                                              >
                                                {district.district_name}
                                              </option>
                                            );
                                          })
                                          : ''}
                                      </Input>
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      City/Town<span className="required">*</span>
                                    </Label>
                                    <div className="select-wrapper">
                                      <Input
                                        type="select"
                                        id="select"
                                        required
                                        multiple={false}
                                        value={
                                          selectedCityId || ""}
                                        onChange={handleCityChange}
                                        disabled={!selectedDistrictId}
                                      >
                                        <option disabled value={''}>
                                          Select
                                        </option>
                                        {selectedCity.length > 0
                                          ? selectedCity.map((val, index) => {
                                            return (
                                              <option key={index} value={val.city_id}>
                                                {val.city_or_town_name}
                                              </option>
                                            );
                                          })
                                          : ''}
                                      </Input>
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={4}>
                              <Label className="common-input-label">
                                Landline Number
                              </Label>
                              <FormGroup className="country-code-group">
                                <Input
                                  className="country-code-input"
                                  type="text"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.stdCode === null ||
                                      formValues.stdCode === 'undefined'
                                      ? ''
                                      : formValues.stdCode
                                  }
                                  onChange={(e) => {
                                    handleChange(e, 10);
                                  }}
                                  placeholder="STD Code"
                                  name="stdCode"
                                />
                                <Input
                                  className="common-input"
                                  name="landlineNumber"
                                  maxLength={10}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  value={
                                    formValues.landlineNumber === null ||
                                      formValues.landlineNumber === 'undefined'
                                      ? ''
                                      : formValues.landlineNumber
                                  }
                                  onChange={(e) => {
                                    handleChange(e, 3);
                                  }}
                                  placeholder="Type Here"
                                  type="text"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <Label className="common-input-label">Website</Label>
                              <Input
                                className="common-input"
                                type="text"
                                autoComplete="off"
                                value={
                                  formValues.Website === null ||
                                    formValues.Website === 'undefined'
                                    ? ''
                                    : formValues.Website
                                }
                                onChange={(e) => handleChange(e, 1)}
                                placeholder="Type Here"
                                name="Website"
                              />
                            </Col>
                            <Col md={4}>
                              <Label className="common-input-label">
                                Facebook Page Link
                              </Label>
                              <Input
                                className="common-input"
                                onChange={(e) => handleChange(e, 2)}
                                type="text"
                                autoComplete="off"
                                value={
                                  formValues.FbPgLink === null ||
                                    formValues.FbPgLink === 'undefined'
                                    ? ''
                                    : formValues.FbPgLink
                                }
                                placeholder="Type Here"
                                name="FbPgLink"
                              />
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <h3 className="dealerRegBlocktitleInner">Shop Information</h3>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Enter Frontage (Ft)<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  value={
                                    formValues.frontAge === null ||
                                      formValues.frontAge === 'undefined'
                                      ? ''
                                      : formValues.frontAge
                                  }
                                  onChange={(e) => handleChange(e, 4)}
                                  type="text"
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  placeholder="Type Here"
                                  name="frontAge"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Enter Depth (Ft)<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  value={
                                    formValues.depth === null ||
                                      formValues.depth === 'undefined'
                                      ? ''
                                      : formValues.depth
                                  }
                                  onChange={(e) => handleChange(e, 5)}
                                  type="text"
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  placeholder="Type Here"
                                  name="depth"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Enter Ceiling Height (Ft)
                                  <span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  value={
                                    formValues.ceilingHeight === null ||
                                      formValues.ceilingHeight === 'undefined'
                                      ? ''
                                      : formValues.ceilingHeight
                                  }
                                  onChange={(e) => handleChange(e, 6)}
                                  placeholder="Type Here"
                                  name="ceilingHeight"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <h3 className="dealerRegBlocktitleInner">
                            Storage Information
                          </h3>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Total Area of Storage (in Sqft)
                                  <span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  value={
                                    formValues.totalAreaStorage === null ||
                                      formValues.totalAreaStorage === 'undefined'
                                      ? ''
                                      : formValues.totalAreaStorage
                                  }
                                  onChange={(e) => handleChange(e, 4)}
                                  type="text"
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  placeholder="Type Here"
                                  name="totalAreaStorage"
                                />
                              </FormGroup>
                            </Col>
                            <Col xs={12}>
                              <div className="common-buttons d-flex flex-wrap align-items-center justify-content-center">
                                {isKycRequired ? (
                                  // <Button
                                  //   id='SaveAsDraft'
                                  //   name='SaveAsDraft'
                                  //   onClick={handleBack}
                                  //   className='businessBtn noprint'
                                  // >
                                  //   Cancel
                                  // </Button>
                                  <CommonButton
                                    name={'Cancel'}
                                    btnClass={'btnSecondary'}
                                    type="button"
                                    onClick={handleBack}
                                  />
                                ) : (
                                  // <Button
                                  //   id='SaveAsDraft'
                                  //   name='SaveAsDraft'
                                  //   onClick={handleSaveAsDraft}
                                  //   className='businessBtn noprint'
                                  // >
                                  //   Save as Draft
                                  // </Button>
                                  <CommonButton
                                    name={'Save as Draft'}
                                    btnClass={'btnSecondary'}
                                    type="button"
                                    onClick={handleSaveAsDraft}
                                  />
                                )}
                                {/* <Button
                        type='submit'
                        id='Submit'
                        name='Submit'
                        className={'businessBtn noprint'}
                      >
                        Submit
                      </Button> */}
                                <CommonButton
                                  name={'Submit'}
                                  btnClass={'btnPrimary'}
                                  type="submit"
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessInfo;
